import { ContainerModule } from 'inversify';
import { interfaces } from 'inversify/lib/interfaces/interfaces';

import { DIAlreadyOverriddenError } from '../errors/already-overridden';

export type DepOverride<T = any> = [interfaces.Newable<T>, interfaces.Newable<T>]
export class ActrContainerModule extends ContainerModule {

  protected _overriddenDeps: DepOverride[] = [];

  constructor(registry: (
    this: { getOverriddenDeps: () => DepOverride[] },
    ...args: Parameters<interfaces.ContainerModuleCallBack>
  ) => ReturnType<interfaces.ContainerModuleCallBack>) {
    super(registry.bind({
      getOverriddenDeps: () => this._overriddenDeps,
    }));
  }

  addOverrides<T>(override: DepOverride<T>) {
    this._overriddenDeps.push(override);

    return this;
  }

}

export const overriddenDeps: DepOverride[] = [];

export function defineDIModule(dependencies: interfaces.Newable<any>[]) {
  return new ActrContainerModule(function (bind, _, isBound) {
    const overrides = this.getOverriddenDeps();

    dependencies.forEach(target => {
      if (!isBound(target)) {
        const override = overrides.find(([overrideTarget]) => overrideTarget === target);

        if (override) {
          const [, overrideResult] = override;

          bind(target).to(overrideResult).inSingletonScope();

          const existedOverrideVariant = overriddenDeps.find(([overrideTarget]) => overrideTarget === target);

          if (existedOverrideVariant && existedOverrideVariant[1] !== overrideResult) {
            throw new DIAlreadyOverriddenError({
              target,
              overrideResult,
              existedOverrideVariant: existedOverrideVariant[1]
            });
          } else {
            overriddenDeps.push([target, overrideResult]);
          }
        } else {
          bind(target).toSelf().inSingletonScope();
        }
      }
    });
  });
}
